import React from 'react';
import styled from 'styled-components';

import theme from '../../../theme';

interface Props {
  onClick: () => void;
  active: boolean;
}

export const Button: React.FC<Props> = props => {
  const { onClick, active, children } = props;
  return (
    <StyledButton onClick={onClick} active={active}>
      {children}
    </StyledButton>
  );
};

const StyledButton = styled.button<{
  active: boolean;
}>`
  color: ${theme.colors.text.grey};
  background-color: ${theme.colors.white};
  border: none;
  border-radius: 1000px;
  padding: 10px 40px;
  font-weight: 600;
  height: 48px;
  display: flex;
  font-size: 16px;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.25);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

  cursor: pointer;
  touch-action: manipulation;

  &:active {
    box-shadow: none;
  }
  &:focus {
    outline: none;
  }
  &:hover {
    background-color: #ffac68;
    color: ${props => (props.active ? theme.colors.white : theme.colors.white)};
  }
`;
